<template>
  <Page mode="jacket">
    <div class="MainData">
      <h1 class="delete-heading">{{ labels.Title }}</h1>
      <p class="delete-para" v-html="labels.Description"></p>
      <b-button
        :aria-label="labels.DeleteUser"
        type="submit"
        variant="primary"
        @click="showModal"
        class="w-60 mt-2 p-2 pl-4 pr-4 rounded vgs-form-button"
        >{{ labels.DeleteUser }}</b-button
      >
    </div>
    <b-modal
      ref="delete-user-modal"
      id="modal"
      modal-class="delete-user-modal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <template #modal-header="{ close }">
        <button class="custom-close" @click="close()">&times;</button>
      </template>
      <h1 class="delete-modal-heading">{{ labels.DeleteUser }}</h1>

      <p class="my-4 align-items-center delete-para">
        {{ labels.DeleteUserInfoText }}
      </p>
      <div class="row justify-content-end align-items-center">
        <div class="col-md-2 col-sm-2">
          <router-link to="/">{{ labels.Close }}</router-link>
        </div>
        <div class="col-md-5 col-sm-5">
          <b-button
            :aria-label="labels.Save"
            type="submit"
            @click="fm_submit()"
            variant="primary"
            class="w-60 mt-2 p-2 pl-4 pr-4 rounded vgs-form-button"
            >{{ labels.DeleteUser }}</b-button
          >
        </div>
      </div>
    </b-modal>
  </Page>
</template>

<script>
import Page from "@/structure/Page.vue";
import axios from "axios";
import { vcm } from "@/mixins/vcm";
import { mapActions } from "vuex";
import Vue from "vue";
export default {
  name: "DeleteUser",
  mixins: [vcm],
  components: {
    Page,
  },
  data() {
    return {
      labels: {
        Title: " Benutzer löschen ",
        Description:
          "Sind Sie sicher, dass Sie Ihren Zugang zu Kaerstin fur den Benutzer ##USERNAME## und alle damit verbundenenDaten unwiderruflich loschen wollen",
        DeleteUser: this.get_scope_translation("DeleteUser", "label"),
        DeleteUserInfoText: this.get_scope_translation(
          "DeleteUserInfoText",
          "label"
        ),
        Close: this.get_scope_translation("Close", "label"),
      },
    };
  },
  mounted() {
    let valid=  localStorage.getItem("isDeletePageAccessible");
    if(!valid)
     this.$root.goto("startpage");
    const FiledLabels = this.$root.get_label_fields(
      `${this.$root.config.localization.language}`,
      "DeleteUser"
    );
    Object.assign(this.labels, FiledLabels);
  },
   destroyed() {
    localStorage.removeItem('isDeletePageAccessible');
  },
  async created() {
    try {
      const Url = process.env.VUE_APP_BASE_URL + `/v1/pages/removeuser`;
      const token = Vue.vclGet("access_token", "");
      const Name = Vue.vclGet("user_name", "");
      const response = await axios.get(Url, {
        params: { language: `${this.$root.config.localization.language}` },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.responseCode === "200" && response.data.response) {
        this.labels.Title = response.data.response.Title;
        this.labels.Description = response.data.response.Description.replace(
          /##USERNAME##/g,
          `<strong>${Name}</strong>`
        );
      }
    } catch (e) {
      console.log("Error : " + e);
    }
  },

  methods: {
   ...mapActions({
      deleteUser: "setting/getDeleteUser",
    }),
    showModal() {
      this.$refs["delete-user-modal"].show();
    },
    fm_submit() {   
       this.deleteUser().then((result) => {
        if(result.responseCode === '200' || result.responseMessage === 'Ok'){
           this.$root.sign_out();
           this.$router.push({ name: "thankyou" });
       }
       })
       },
  },
};
</script>


<style>
.delete-user-modal{
  margin-top: 4%;
}
.delete-heading{
  font-size: 30px !important;
  padding-left: 0 !important;
  border: none;
  margin-bottom: 1rem;
}
.delete-modal-heading{
  font-size: 26px !important;
  padding-left: 0 !important;
  border: none;
  margin-bottom: 1rem;
}
.delete-para {
  font-size: 16px !important;
}
.MainData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 79vh;
}
.custom-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: transparent;
  color: black;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid black;
  outline: none;
}
div#modal .modal-dialog.modal-md .modal-content {
  border-radius: 0 !important;
}
@media (max-width: 991px) {
  .MainData {
    height: 45vh;
    padding-left: 35px;
    padding-right: 35px;
  }
}
@media (min-width: 180px){
.col-sm-5{
  width: auto;
}
.col-md-5{
  width: auto;
}
.col-sm-2{
width: auto;
}
}
</style>